// modules/LFSSButton.js
import React         from 'react';

class LFSSButton extends React.Component {
	render() {
			return (
				<a href={this.props.path} target={this.props.target} onClick={(e) => this.props.onClick(e)}>
					<div className="LFSS-Button">
						{this.props.children}
					</div>
				</a>
			);
	}
}

export default LFSSButton;


/** WEBPACK FOOTER **
 ** ./src/modules/common/LFSSButton.js
 **/